import { render, staticRenderFns } from "./Sdg06.vue?vue&type=template&id=257e2b93&scoped=true&"
import script from "./Sdg06.vue?vue&type=script&lang=js&"
export * from "./Sdg06.vue?vue&type=script&lang=js&"
import style0 from "./Sdg06.vue?vue&type=style&index=0&id=257e2b93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e2b93",
  null
  
)

export default component.exports